import { render } from "./AutoLogout.vue?vue&type=template&id=4d38a822&scoped=true"
import script from "./AutoLogout.vue?vue&type=script&lang=js"
export * from "./AutoLogout.vue?vue&type=script&lang=js"

import "./AutoLogout.vue?vue&type=style&index=0&id=4d38a822&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d38a822"]])

export default __exports__